import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { RootState } from "@/redux/reducers";

const selectLocation = (state: RootState) => state?.location;

export default createDraftSafeSelector(selectLocation, (location) => location?.latitude);
